import {Link} from 'react-router-dom';

export default function Navf() {
    return (
        <nav class="Navf">
            <Link to="/" class="NavfItem">Home</Link>
            <Link to="/tutors-list-page" class="NavfItem">Tutors</Link>
            <Link class="NavfItem">Join us</Link>
            <Link class="NavfItem">About</Link>
            <Link class="NavfItem">Contact</Link>
        </nav>
    )
}